/* eslint-disable import/prefer-default-export */
import axios from '../axios';
import { get, map } from 'lodash-es';
import { useMutation, useQuery, useQueryClient } from 'react-query';

// List Chargers
export function useFetchCorporateChargersList({ filter = 'all', corporateId }) {
  // const axios = useAxios();

  const effectiveFilter = {
    all: {},
    online: { IS_AVAILABLE: true },
    enabled: { IS_ENABLED: 1 },
    disabled: { IS_ENABLED: 0 },
  }[filter];

  return useQuery(['corporateChargers/list', filter], () =>
    axios
      .get(`/corporate/charger`, {
        params: { ...effectiveFilter },
      })
      .then((result) => ({
        list: map(get(result, 'data.data', []), (cp) => ({
          id: cp.ID,
          charger: cp.CHARGER,
          group: cp.LOCATION,
          plan: cp.NAME_1,
          name: cp.NAME,
          address: get(cp, 'ADDRESS'),
          isOnline: !!get(cp, 'IS_AVAILABLE'),
          isEnabled: !!get(cp, 'IS_ENABLED'),
          type: cp.IS_DC === 0 ? 'AC' : 'DC',
          createdAt: cp.CREATED_AT,
          lat: get(cp, 'LATITUDE'),
          lon: get(cp, 'LONGITUDE'),
          capacity: get(cp, 'ENERGY'),
          state: get(cp, 'STATE'),
          ...cp,
        })),
        total: get(result, 'data.count', 0),
      })),
  );
}

// Create Charger
export function useCreateCorporateChargerMutation() {
  const queryClient = useQueryClient();
  // const axios = useAxios();

  return useMutation((cp) => axios.post('/corporateCharger', cp), {
    onSuccess: () => {
      queryClient.invalidateQueries('corporateChargers/list');
    },
  });
}

// Edit Corporate Plan
export function useEditCorporateChargerMutation() {
  // const axios = useAxios();
  return useMutation((corporateCharger) =>
    axios.put(
      `/corporateCharger/${corporateCharger.CHARGER}`,
      corporateCharger,
    ),
  );
}

// Get Corporate Charger By Id
export function useFetchCorporateChargerByID(cpid) {
  // const axios = useAxios();
  return useQuery(['corporateCharger/id', cpid], () =>
    axios.get(`/corporate/charger/${cpid}`).then((result) => {
      return result?.data;
    }),
  );
}

// Disable Charger
export function useDisableChargerMutation() {
  const queryClient = useQueryClient();
  // const axios = useAxios();

  return useMutation(
    (cpid) => axios.put(`/corporate/charger/${cpid}`, { IS_ENABLED: 0 }),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['charger/details', variables.ChargerId]);
        return data;
      },
    },
  );
}

// Enable Charger
export function useEnableChargerMutation() {
  const queryClient = useQueryClient();
  // const axios = useAxios();

  return useMutation(
    (cpid) => axios.put(`/corporate/charger/${cpid}`, { IS_ENABLED: 1 }),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['charger/details', variables.ChargerId]);
        return data;
      },
    },
  );
}

// Corporate Charger Analytics
export function useChargersAnalytics(cpid) {
  // const axios = useAxios();
  return useQuery(['corporateCharger/id', cpid], () =>
    axios.get(`/corporate/charger/${cpid}`).then((result) => {
      return result?.data;
    }),
  );
}

// Clear cache
export function useClearCacheMutation() {
  // const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation(
    // eslint-disable-next-line no-unused-vars
    ({ ChargerId }) => axios.post(`/corporate/clearCache/${ChargerId}`),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['charger/details', variables.ChargerId]);
        return data;
      },
    },
  );
}

// reset Charger
export function useResetChargerMutation() {
  // const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation(
    // eslint-disable-next-line no-unused-vars
    ({ ChargerId, type }) =>
      axios.post(`/corporate/reset/${ChargerId}`, {
        type,
      }),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['charger/details', variables.ChargerId]);
        return data;
      },
    },
  );
}
